import styles from './/styles.module.scss'
import React, { useEffect, useState } from 'react'
import '@/src/extensions/number'
import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import CreateElements from '@/src/components/helpers/create-elements/create-elements'
import ActionCheckbox from '@/src/components/misc/action-elements/action-checkbox/action-checkbox'
import BackButton from '@/src/components/misc/back-button/back-button'
import ItemInfos from '@/src/interfaces/catalog/item-infos'
import { CurrentHalfSelectedComplements } from '../config-product-by-size'
import { ItemService } from '@/src/services/catalog/item-service'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import { useAppAccessToken } from '@/src/context/app-access-token/app-access-token-context'

interface ChooseHalfComplementsProps {
    halfId: string,
    halfTitle: string,
    complementsSelected: ItemInfos.Complement[],
    quantityOfParts: number,
    moveBack(): void,
    handleComplements(e: CurrentHalfSelectedComplements): void
}

export default function ChooseHalfComplements({ complementsSelected, halfTitle, halfId, quantityOfParts, handleComplements, moveBack }: ChooseHalfComplementsProps) {
    const [complements, setComplements] = useState<ItemInfos.Complement[] | undefined>(undefined)
    const [selectedsComplements, setSelectedComplements] = useState<ItemInfos.Complement[] | undefined>(complementsSelected)
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(true)
    const { merchantSummary, localMode } = useMerchant()
    const { appAccessToken } = useAppAccessToken()

    const isItemSelected = (item: ItemInfos.Complement) => {
        return (selectedsComplements?.some((complement) => complement.id === item.id)) ?? false
    };

    const confirmChoice = () => {
        const halfGroup: CurrentHalfSelectedComplements = {
            id: halfId,
            sizeComplements: selectedsComplements ?? [],
            name: halfTitle
        }
        handleComplements(halfGroup)
        moveBack()
    }

    const setComplementsPerHalf = (item: ItemInfos.Complement) => {
        if (selectedsComplements?.some(c => c.id === item.id)) {
            const updatedComplements = selectedsComplements?.filter(c => c.id !== item.id)
            setSelectedComplements(updatedComplements)
        } else {
            const updatedComplements: ItemInfos.Complement[] = [...(selectedsComplements ?? []), item]
            setSelectedComplements(updatedComplements)
        }
    }

    const renderComplements = () => {
        if (complements?.length === 0)
            return <div className={styles.emptyComplements}><p>Não há complementos</p></div>

        return (
            <div className={styles.complements}>
                {
                    complements?.map((complements) => (
                        <div onClick={() => setComplementsPerHalf(complements)} key={complements.id} className={styles.items}>
                            <p>1/{quantityOfParts} {complements.name}</p>
                            <div className={styles.priceAndCheckbox}>
                                <div className={styles.prices}>
                                    {quantityOfParts > 1 && <del>+{complements.salePrice.toLocalePrice()}</del>}
                                    <span>+{((complements.salePrice / quantityOfParts)).toLocalePrice()}</span>
                                </div>
                                <ActionCheckbox checked={isItemSelected(complements)} />
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }

    useEffect(() => {
        const getHalfComplements = async () => {
            try {
                const params: ItemInfos.ComplementSearchParams = {
                    ids: [halfId],
                    merchantId: merchantSummary?.id!,
                    sellLocal: !!localMode
                }

                const response = await ItemService.getComplements(params, appAccessToken)

                if (response.success) {
                    if (response.model) {
                        let responseHalfComplementList = response.model.merchantItems.map((item) => item.complements).flat()
                        setComplements(responseHalfComplementList)
                    }
                } else {
                    setErrorMessage(response.errorMessage)
                }
            } catch (e: any) {
                setErrorMessage(e.toString())
            } finally {
                setLoading(false)
            }
        }

        getHalfComplements()
    }, [])

    if (errorMessage) {
        return <div className={styles.container}>
            <h3>{errorMessage}</h3>
        </div>
    }

    return (
        <div className={styles.container}>
            <div className={styles.head}>
                <BackButton className={styles.backButton} onClick={() => moveBack()} />
                <div className={styles.headTitleArea}>
                    <b className='font-xmd'>Complementos para esta parte</b>
                    <h3 className={`${styles.halfName} font-xlg`}>{halfTitle}</h3>
                </div>
            </div>
            {
                loading ?
                    <BaseLoading>
                        <div className={styles.complements}>
                            <CreateElements quantity={6}>
                                <div className={styles.items}>
                                    <aside className={styles.imageArea} style={{ height: '36px', width: '80%' }}></aside>
                                    <aside className={styles.imageArea} style={{ height: '36px', width: '10%' }}></aside>
                                </div>
                            </CreateElements>
                        </div>
                    </BaseLoading>
                    :
                    renderComplements()
            }
            <div className={styles.bottom}>
                <button className={styles.btnBottomCancel} onClick={() => moveBack()}>Cancelar</button>
                <button className={styles.btnBottomConfirm} onClick={() => confirmChoice()}>Confirmar</button>
            </div>
        </div >
    )
}
